module.exports = __webpack_public_path__ + "img/collection-play.4b1ffd11.svg";